import React, { useEffect, useState } from "react";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  getAllCoins,
  getCoinGeneralSettings,
  updateCoinGeneralSettings,
} from "../../../api/coin";

const CardBlog = () => {
  const [allCoins, setAllCoins] = useState([]);
  const [selectedCoins, setSelectedCoins] = useState({});
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const fetchAllCoins = async () => {
    setLoading(true);
    try {
      const res = await getAllCoins(1, 1000);
      setAllCoins(
        res?.data?.map((coin) => ({
          value: coin?.id.toLowerCase(),
          label: `${coin.name} (${coin.symbol})`,
        })) || []
      );
    } catch (err) {
      console.error("Failed to fetch coins", err);
      Swal.fire("Error", "Failed to load coin list.", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchSelectedCoins = async () => {
    try {
      const res = await getCoinGeneralSettings();
      setSelectedCoins({
        gainers: res.topGainers?.map((item) => item["id"]) || [],
        losers: res.topLosers?.map((item) => item["id"]) || [],
        highlights: res.topHighLights?.map((item) => item["id"]) || [],
        listing: res.topListings?.map((item) => item["id"]) || [],
      });
    } catch (err) {
      console.error("Failed to fetch selected coins", err);
      Swal.fire("Error", "Failed to load selected coins.", "error");
    }
  };

  useEffect(() => {
    fetchAllCoins();
    fetchSelectedCoins();
  }, []);

  const handleChange = (section, selectedOptions) => {
    console.log("selectedOptions", selectedOptions);
    setSelectedCoins((prev) => ({
      ...prev,
      [section]: selectedOptions.map((opt) => opt.value),
    }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await updateCoinGeneralSettings({
        topGainers: selectedCoins.gainers,
        topLosers: selectedCoins.losers,
        topHighLights: selectedCoins.highlights,
        topListings: selectedCoins.listing,
      });
      Swal.fire("Success", "Selections saved successfully!", "success");
    } catch (err) {
      console.error("Error saving selections", err);
      Swal.fire("Error", "Error saving selections", "error");
    } finally {
      setSaving(false);
    }
  };

  const getDefaultValues = (section) => {
    const selected = selectedCoins[section] || [];
    console.log("selected", selected);
    return allCoins.filter((coin) => selected?.includes(coin.value));
  };

  return (
    <div className="container-fluid mt-4">
      <h3 className="card-title">Admin Coin Selector</h3>
      {loading ? (
        <p>Loading coins...</p>
      ) : (
        <>
          {[
            { key: "gainers", label: "Top" },
            { key: "losers", label: "Top Losers" },
            { key: "highlights", label: "Top Highlights" },
            { key: "listing", label: "Top Listings" },
          ].map(({ key, label }) => (
            <div key={key} className="mb-4">
              <label className="form-label fw-bold">{label}</label>
              <Select
                isMulti
                options={allCoins}
                value={getDefaultValues(key)}
                onChange={(options) => handleChange(key, options)}
              />
            </div>
          ))}
          <button
            className="btn btn-primary"
            onClick={handleSave}
            disabled={saving}>
            {saving ? "Saving..." : "Save Selections"}
          </button>
        </>
      )}
    </div>
  );
};

export default CardBlog;
